export const NO_INITIAL = '#';

const stripAccents = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g, '');

/** Letter a contact is filed under: first letter, no accent, upper case; anything else → `#`. */
export const initialOf = (name) => {
  const first = stripAccents((name || '').trim()).charAt(0).toUpperCase();
  return /^[A-Z]$/.test(first) ? first : NO_INITIAL;
};

/** Up to two letters for the avatar ("Maria da Silva" → "MD"). */
export const contactInitials = (name) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};

/**
 * Contacts already sorted by name → [{ letter, items }], in the order the
 * letters first appear and with `#` last. A letter that shows up again later
 * (database collation, or a page loaded afterwards) joins its existing group.
 */
export const groupByInitial = (contacts) => {
  const groups = new Map();
  contacts.forEach((contact) => {
    const letter = initialOf(contact.display_name);
    if (!groups.has(letter)) groups.set(letter, []);
    groups.get(letter).push(contact);
  });
  const entries = [...groups.entries()].map(([letter, items]) => ({ letter, items }));
  return [
    ...entries.filter((group) => group.letter !== NO_INITIAL),
    ...entries.filter((group) => group.letter === NO_INITIAL),
  ];
};
